var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopsStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1248 32.0833H21.8748C29.1665 32.0833 32.0832 29.1666 32.0832 21.875V13.125C32.0832 5.83329 29.1665 2.91663 21.8748 2.91663H13.1248C5.83317 2.91663 2.9165 5.83329 2.9165 13.125V21.875C2.9165 29.1666 5.83317 32.0833 13.1248 32.0833Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6042 26.9792C24.2083 26.9792 25.5208 25.6667 25.5208 24.0625V10.9375C25.5208 9.33337 24.2083 8.02087 22.6042 8.02087C21 8.02087 19.6875 9.33337 19.6875 10.9375V24.0625C19.6875 25.6667 20.9854 26.9792 22.6042 26.9792Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3957 26.9791C13.9998 26.9791 15.3123 25.6666 15.3123 24.0625V18.9583C15.3123 17.3541 13.9998 16.0416 12.3957 16.0416C10.7915 16.0416 9.479 17.3541 9.479 18.9583V24.0625C9.479 25.6666 10.7769 26.9791 12.3957 26.9791Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopsStat);
export default __webpack_public_path__ + "static/media/tops-stat.e437a897bf7f6c524fcaf915462f107f.svg";
export { ForwardRef as ReactComponent };